import { render, staticRenderFns } from "./LessonsTable.vue?vue&type=template&id=5ab33f3b&"
import script from "./LessonsTable.vue?vue&type=script&lang=js&"
export * from "./LessonsTable.vue?vue&type=script&lang=js&"
import style0 from "./LessonsTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VCard,VSimpleTable})
